/* import __COLOCATED_TEMPLATE__ from './content-v2.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface Signature {
  Args: {
    finIsLive: boolean;
    openSectionId?: string;
    setOpenSectionId: (sectionId: string) => void;
    showPreview: boolean;
    togglePreview: () => void;
  };
  Blocks: {
    default: [];
  };
}

/**
 * Wrapper component that conditionally renders the new Content V2 interface
 * when the feature flag is enabled, otherwise falls back to the existing content view.
 */
export default class ContentV2 extends Component<Signature> {
  @service declare appService: AppService;

  /**
   * Determines if the new Content V2 interface should be shown
   * based on the feature flag
   */
  get shouldShowNewInterface(): boolean {
    return this.appService.app.canUseFeature('team-knowledge-foundations-content-setup-v2');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::ContentV2': typeof ContentV2;
    'fin-ai-agent/knowledge/content-v2': typeof ContentV2;
  }
}
